import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

type ClickableProps =
    | (Omit<React.ComponentPropsWithoutRef<'a'>, 'href'> & {
          href: string
      })
    | React.ComponentPropsWithoutRef<'button'>

// Turn any arbitrary component into a clickable component, wrapped with a link
export function Clickable({ children, className, ...props }: ClickableProps) {
    const mergedClassName = twMerge(
        'cursor-pointer hover:bg-white hover:bg-linear-to-b hover:from-black/4 hover:to-black/4 hover:text-gray-700',
        'active:bg-linear-to-b active:from-black/8 active:to-black/8',
        'disabled:border-gray-200',
        className
    )

    if ('href' in props) {
        const { href, ...rest } = props
        return (
            <Link to={href} className={mergedClassName} {...rest}>
                {children}
            </Link>
        )
    }

    return (
        <button className={mergedClassName} {...props}>
            {children}
        </button>
    )
}
